import React from 'react';
import { PhoneOffIcon, ClockAlertIcon, UsersIcon } from 'lucide-react';
import { Card, CardHeader, CardBody } from '../Card';
import { Badge } from '../Badge';
type Problem = {
  icon: React.ReactNode;
  title: string;
  body: string;
};
const PROBLEMS: Problem[] = [{
  icon: <PhoneOffIcon className="h-6 w-6" aria-hidden="true" data-id="element-236" data-mp="djwqoo8j17pg" />,
  title: '電話・予約対応で本業が止まる',
  body: '作業の手を止めて電話に出て、予約を書き留め、また作業に戻る。その繰り返しで、本来集中したい仕事がなかなか進みません。'
}, {
  icon: <ClockAlertIcon className="h-6 w-6" aria-hidden="true" data-id="element-237" data-mp="3vo86ffvhoi81" />,
  title: '営業時間外の取りこぼし',
  body: '夜間や定休日にかかってきた電話、届いた問い合わせ。出られなかったその一件が、そのまま機会損失につながっているかもしれません。'
}, {
  icon: <UsersIcon className="h-6 w-6" aria-hidden="true" data-id="element-238" data-mp="3lsn4tiuc1jyt" />,
  title: '採用は難しく、人件費は上がる',
  body: '受付や電話番のために人を雇うのは簡単ではなく、コストも増え続けます。今いるスタッフの負担も限界に近づいています。'
}];
export function ProblemSection() {
  return <section id="problem" className="w-full scroll-mt-24 bg-surface-muted" data-id="element-239" data-mp="1k0iay1t9wclg">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24" data-id="element-240" data-mp="1oy0k9tb7cttz">
        <div className="mx-auto max-w-2xl text-center" data-id="element-241" data-mp="1nnkvc0lhfz5y">
          <Badge variant="sky" data-id="element-242" data-mp="1nm05upe0z6ey">よくあるお悩み</Badge>
          <h2 className="mt-4 text-2xl font-bold text-text sm:text-3xl" data-id="element-243" data-mp="1ip9o7xmko2rf">
            こんな「現場の困りごと」、ありませんか？
          </h2>
          <p className="mt-4 text-base leading-relaxed text-text-muted" data-id="element-244" data-mp="1wf3e8j9tct2q">
            人手が足りない毎日。電話や予約、問い合わせへの対応に追われ、本来やるべき仕事に集中できない——
            多くの地域ビジネスの経営者さまが、同じ悩みを抱えています。
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-245" data-mp="14q0b56tnxoro">
          {PROBLEMS.map(p => <Card key={p.title} variant="outlined" className="h-full" data-id="element-246" data-mp="zqxcq586ugso">
              <CardHeader data-id="element-247" data-mp="1dpf0g2y3ftal">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-white text-deep-navy ring-1 ring-border" data-id="element-248" data-mp="1dqpyrn8rs8ub">
                  {p.icon}
                </span>
                <h3 className="mt-4 text-lg font-bold text-text" data-id="element-249" data-mp="2p40ukgugsfsu">{p.title}</h3>
              </CardHeader>
              <CardBody data-id="element-250" data-mp="2k4pbv2ajf08m">{p.body}</CardBody>
            </Card>)}
        </div>
      </div>
    </section>;
}